// ============================================================
// instanceText - what to CALL a talent or trait on a sheet.
//
// A catalog entry is called by its catalog name; a custom entry by the
// name it was written down with. An id that is neither (a stale id from
// an older catalog) has no text and is not shown.
// ============================================================
import type { TalentInstance, TraitInstance } from './types';
import { TALENT_CATALOG } from './talentCatalog';
import { TRAIT_CATALOG } from './traitCatalog';
import { CUSTOM_ENTRY_ID } from './instanceEdits';

export interface InstanceText {
  name: string;
  description: string;
  /** Written down by the table rather than taken from a catalog. */
  custom: boolean;
}

function textFor(
  def: { name: string; description: string } | undefined,
  id: string,
  inst: { name?: string; note?: string },
): InstanceText | null {
  if (def) return { name: def.name, description: def.description, custom: false };
  if (id !== CUSTOM_ENTRY_ID) return null;
  return { name: inst.name || 'Custom', description: inst.note ?? '', custom: true };
}

export function talentText(inst: TalentInstance): InstanceText | null {
  return textFor(TALENT_CATALOG[inst.talentId], inst.talentId, inst);
}

export function traitText(inst: TraitInstance): InstanceText | null {
  return textFor(TRAIT_CATALOG[inst.traitId], inst.traitId, inst);
}
